/* =========================================
   AI Storage Manager

   Product isolated localStorage system

   namespace:

   zalanda_{CURRENT_SKU}_{key}

========================================= */


window.AI_STORAGE = {


    getProductKey(){


        return window.CURRENT_SKU || "default";


    },





    getKey(name){


        return `zalanda_${this.getProductKey()}_${name}`;


    },





    set(name,value){


        try{


            localStorage.setItem(

                this.getKey(name),

                JSON.stringify(value)

            );


        }
        catch(error){


            console.error(
                "[AI_STORAGE] Save failed:",
                error
            );


        }


    },






    get(name, defaultValue=null){


        try{


            const data =
            localStorage.getItem(
                this.getKey(name)
            );


            if(!data){

                return defaultValue;

            }


            return JSON.parse(data);


        }
        catch(error){


            console.error(
                "[AI_STORAGE] Read failed:",
                error
            );


            return defaultValue;


        }


    },






    remove(name){


        localStorage.removeItem(

            this.getKey(name)

        );


    },






    clearProduct(){


        const prefix =
        `zalanda_${this.getProductKey()}_`;



        Object.keys(localStorage)
        .forEach(key=>{


            if(key.startsWith(prefix)){


                localStorage.removeItem(key);


            }


        });


    }

};